import { Sandwich, CircleDot, Beef, Fish, Cookie } from "lucide-react";

const Menu = () => {
  const menuCategories = [
    {
      title: "Montaditos",
      icon: Sandwich,
      items: [
        "Piripi",
        "Solomillo al whisky",
        "Queso roll",
        "Queso azul con chorizo picante",
        "Chicharrón de Cádiz con queso fundido",
      ],
    },
    {
      title: "Croquetas Artesanales",
      icon: Cookie,
      items: [
        "Croquetas de jamón",
        "Croquetas de queso azul con nueces",
        "Croquetas de gambas al ajillo",
        "Croquetas de queso Apolonio",
      ],
    },
    {
      title: "Ibéricos de Bellota",
      icon: CircleDot,
      items: [
        "Jamón ibérico de bellota",
        "Paletilla ibérica",
        "Caña de lomo",
        "Salchichón ibérico",
        "Chorizo ibérico",
        "Morcón",
      ],
    },
    {
      title: "Carnes a la Brasa",
      icon: Beef,
      items: [
        "Solomillo ibérico",
        "Secreto ibérico",
        "Lagartito ibérico",
        "Presa ibérica",
        "Entrecot de vaca retinta",
      ],
    },
    {
      title: "Pescados y Mariscos",
      icon: Fish,
      items: [
        "Chocos fritos",
        "Boquerones fritos",
        "Doradas",
        "Lubinas",
        "Gambas",
        "Langostinos",
      ],
    },
  ];

  return (
    <section id="carta" className="section-padding bg-[#F9F7F2]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="font-accent text-[#800020] text-lg mb-4">
            La Carta
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] mb-4">
            Tapas Gourmet en Sevilla Este
          </h2>
          <div className="elegant-divider">
            <span className="font-accent text-[#C5A059]">Mercado de Abastos</span>
          </div>
        </div>

        {/* Menu Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {menuCategories.map((category, index) => (
            <div
              key={index}
              className="bg-white p-8 border border-transparent hover:border-[#DCD7CC] transition-all duration-300 hover-lift"
              data-testid={`menu-category-${index}`}
            >
              {/* Category Header */}
              <div className="flex items-center gap-4 mb-6 pb-4 border-b border-[#DCD7CC]">
                <div className="w-12 h-12 flex items-center justify-center border border-[#C5A059]">
                  <category.icon size={20} className="text-[#800020]" />
                </div>
                <h3 className="font-heading text-xl text-[#1A1A1A]">
                  {category.title}
                </h3>
              </div>

              {/* Items */}
              <ul className="space-y-3">
                {category.items.map((item, itemIndex) => (
                  <li
                    key={itemIndex}
                    className="font-body text-[#1A1A1A]/80 flex items-center gap-2"
                  >
                    <span className="w-1.5 h-1.5 bg-[#C5A059] rounded-full flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Additional info */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-white px-8 py-6 border border-[#DCD7CC]">
            <p className="font-accent text-lg text-[#1A1A1A] mb-2">
              "La buena comida merece disfrutarse sin prisa"
            </p>
            <p className="font-body text-sm text-[#1A1A1A]/60">
              Todos nuestros platos se elaboran con productos de máxima calidad
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Menu;
